import { layers } from './layers';
import { filters } from './filters';
import { multiparcelReport } from './multiparcel-report';
import { parcelReport } from './parcel-report';
import { information } from '../../../packages/configs/information';

export default {
  city: 'Battle Creek',
  state: 'MI',
  defaultZipcode: '49016',
  type: 'Neighborhood Intel',
  center: {
    lat: 42.2941,
    lng: -85.23146,
  },
  canSignUp: true,
  zoom: 11,
  layers,
  filters,
  information,
  defaultSidebar: 'INFORMATION',
  sidebarFlags: [
    'SEARCH_ADDRESS',
    'STARRED_PARCELS',
    'LAYER_SELECTOR',
    'LAYER_BUILDER',
    // 'SURVEYS',
    'INFORMATION',
  ],
  mapHoverProps: ['parcel_id', 'address'],
  customLayersConfig: {
    styleTypeOptions: ['line', 'fill', 'circle'],
    defaultStyle: {
      type: 'line',
      opacity: 0.8,
      paint: {
        'line-color': '#E2603B',
      },
    },
  },
  reports: [parcelReport, multiparcelReport],
};
